/* DreamCloud → Numbers: the range switch, the tiles and the chart.
 *
 * The range belongs to the store (setRange reloads all three panels, and drops
 * an answer for a range that is no longer selected). The tiles and their
 * comparison wording come from js/rules/dreamcloud.js.
 */
import * as Vue from 'vue';
import { dreamcloud } from '../dreamcloud.js';
import { tiles, compareText } from '../rules/dreamcloud.js';
import { DcChart } from './dc-chart.js';

var RANGES = [
  { id: 'today', label: 'Today' },
  { id: '7', label: '7 days' },
  { id: '14', label: '14 days' },
  { id: '30', label: '30 days' }
];

export const DcNumbers = {
  name: 'DcNumbers',
  components: { DcChart: DcChart },
  setup: function () {
    var state = dreamcloud.state;
    // The range the figures on screen are FOR, which lags state.range while a
    // switch is loading; comparing against it keeps "vs prior 7 days" true.
    var shownRange = Vue.computed(function () {
      return state.summary && state.summary.range ? String(state.summary.range) : state.range;
    });
    var list = Vue.computed(function () {
      return tiles(state.summary).map(function (t) {
        return Object.assign({}, t, { cmp: compareText(t, shownRange.value) });
      });
    });
    var days = Vue.computed(function () { return (state.summary && state.summary.days) || []; });
    return {
      state: state,
      ranges: RANGES,
      list: list,
      days: days,
      setRange: function (id) { if (id !== state.range) dreamcloud.setRange(id); }
    };
  },
  template: [
    '<section class="dc-section dc-numbers" aria-labelledby="dc-numbers-h">',
    '  <div class="dc-numbers__head">',
    '    <h3 class="dc-h" id="dc-numbers-h">Ad clicks &amp; conversions',
    '      <span v-if="state.loading" class="dc-muted dc-updating">Updating&hellip;</span></h3>',
    '    <div class="dc-seg" role="group" aria-label="Period">',
    '      <button v-for="r in ranges" :key="r.id" type="button" class="dc-seg__btn"',
    '        :class="{ \'is-on\': state.range === r.id }" :aria-pressed="state.range === r.id ? \'true\' : \'false\'"',
    '        @click="setRange(r.id)">{{ r.label }}</button>',
    '    </div>',
    '  </div>',
    '',
    '  <p v-if="!state.summary" class="dc-muted">{{ state.error ? "Nothing has loaded yet." : "Loading…" }}</p>',
    '  <template v-else>',
    '    <div class="dc-tiles">',
    '      <div v-for="t in list" :key="t.id" class="dc-tile">',
    '        <div class="dc-tile__label">{{ t.label }}</div>',
    '        <div class="dc-tile__value">{{ t.value }}</div>',
    '        <div v-if="t.cmp" class="dc-tile__cmp" :class="\'is-\' + t.cmp.tone">{{ t.cmp.text }}</div>',
    '        <div v-if="t.sub" class="dc-tile__sub">{{ t.sub }}</div>',
    '      </div>',
    '    </div>',
    '    <dc-chart :days="days" />',
    '  </template>',
    '</section>'
  ].join('\n')
};
